import { Tooltip } from '@linearb/linui-common';
import { checkIfIterationIsTooLong } from 'common/utils/utils';
import { StyledMenuItem } from 'components/PeriodPicker/PeriodPicker.style';
import Icon from 'components/base/Icon';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { currentIterationSelector } from 'state/selectors/iterations-picker';
import { TooLongIterationTooltip } from './TooLongIterationTooltip';
import { noop } from 'lodash';
import useSettingsService from 'components/hooks/useSettingsService';
import { FEATURE_FLAGS_NAMES } from '@linearb/linjs-common';

export const IterationMenuItem = ({ onChange, iteration }) => {
  const currentIteration = useSelector(currentIterationSelector) || {};

  const { getSettingOrDefinitionValue } = useSettingsService();

  const isPreventTooLongIterationsEnabled = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.isPreventTooLongIterationsEnabled
  });

  const { id: selectedIterationId } = currentIteration;
  const { computedName, name, id } = iteration;
  const isSelected = id === selectedIterationId;
  const isIterationTooLong = useMemo(
    () =>
      checkIfIterationIsTooLong({
        iteration,
        isPreventTooLongIterationsEnabled
      }),
    [iteration]
  );
  return (
    <StyledMenuItem
      selected={isSelected}
      onClick={() => {
        isIterationTooLong ? noop() : onChange(iteration);
      }}
      disabled={isIterationTooLong}
      data-testid='iteration-menu-item'
    >
      {computedName || name}
      {isIterationTooLong && (
        <Tooltip placement='left' title={<TooLongIterationTooltip />}>
          <div data-testid='too-long-iteration-icon'>
            <Icon name='InfoOutlined' color='torchRed' />
          </div>
        </Tooltip>
      )}
    </StyledMenuItem>
  );
};
